import { render, staticRenderFns } from "./BannerRenewCertificate.vue?vue&type=template&id=759b4c2b&scoped=true"
import script from "./BannerRenewCertificate.vue?vue&type=script&lang=js"
export * from "./BannerRenewCertificate.vue?vue&type=script&lang=js"
import style0 from "./BannerRenewCertificate.vue?vue&type=style&index=0&id=759b4c2b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "759b4c2b",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ButtonComponent: require('/home/luiz/Sistemas/loja/components/ButtonComponent.vue').default})
